import Vue from "vue";
Vue.config.productionTip = false;
/* Bootstrap */
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
/* App */
import App from "./App.vue";


/* Icons */
import VueSVGIcon from "vue-svgicon";
Vue.use(VueSVGIcon);
import "./compiled-icons/index";
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(BootstrapVueIcons);

import Croppa from "vue-croppa";
Vue.use(Croppa);
/**
 * Router and Layouts management
 * @link https://itnext.io/anyway-heres-how-to-create-a-multiple-layout-system-with-vue-and-vue-router-b379baa91a05
 */

import VeeValidate, { Validator } from "vee-validate";
import FR from "vee-validate/dist/locale/fr";
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' });

Validator.localize("FR", FR);

import VueCloneya from "vue-cloneya";
Vue.use(VueCloneya);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key:  window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
    ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
    libraries: "places", // This is required if you use the Autocomplete plugin
  },
  installComponents: true,
});

import Toasted from "vue-toasted";
import toastConfig from './config/toast';
Vue.use(Toasted, toastConfig);

import './filter'

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
Vue.component("vue-phone-number-input", VuePhoneNumberInput);

import moment from "moment-timezone";

moment.locale("fr");
moment.tz.setDefault('Europe/Paris')

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import VueChatScroll from 'vue-chat-scroll';
Vue.use(VueChatScroll);

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'fr',
  messages: {
    fr: {}
  }
})

var platform = require('platform');


/* Router */
import router from "./router";
import store from "./vuex";
import authService from "./services/auth";
import notiService from './services/notification'
/* Analytics */
import VueGtag from "vue-gtag";
const vueAppGoogleAnalyticsUrl =    window.configs && window.configs.VUE_APP_GOOGLE_ANALYTICS_ID !== ""
? window.configs.VUE_APP_GOOGLE_ANALYTICS_ID: process.env.VUE_APP_GOOGLE_ANALYTICS_ID;
Vue.use( VueGtag, {
  config: {
    id: `${vueAppGoogleAnalyticsUrl}`,
    params: {
      send_page_view: true
    } },
  pageTrackerTemplate( to ) {
    return {
      page_title: to.name,
      page_path: to.path,
      app_name: 'Vitalliance'
    }
  }
}, router );

router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})

router.beforeEach((to, from, next) => {
  const candidateRoutesRegex = /^\/candidate/
  let employeeRoutesRegex = /^\/employee/

  const isCandidateZone =
    candidateRoutesRegex.test(from.path) ||
    candidateRoutesRegex.test(to.path)
  const isEmployeeZone =
    employeeRoutesRegex.test(from.path) ||
    employeeRoutesRegex.test(to.path)

  // If only candidate and employee routes
  if (
    (isCandidateZone || isEmployeeZone) &&
    store.state.auth.loggedIn && localStorage.getItem("token") &&
    from.name !== 'login'
  ) {
    const logout = () => {
      store.dispatch("auth/CLEAR_TOKEN");
      store.dispatch("auth/DISCONNECT");     
      router.push("/public/default")
    }
  
    return authService.checkToken().then((res) => {
      if (!res.success) {
        logout();
      }
      next();
    }).catch((err)=> {
      logout();
    })
  }
  next()
});


Vue.directive('click-outside', {
  bind(el, binding, vnode) {
      var vm = vnode.context;
      var callback = binding.value;

      el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
              return callback.call(vm, event);
          }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

import VueExpandableImage from 'vue-expandable-image'
Vue.use(VueExpandableImage)

/* Init App */
new Vue({
  i18n,
  router,
  render: (h) => h(App),
  store,
}).$mount("#app");
